<template>
  <input
    type="text"
    class="form-control"
    :value="currentId"
    @input="inputId"
    :placeholder="currentId ? currentId : $t('src/components/filters/pagesessionfilter.EnterID')"
    v-on:keypress="onKeydown()"
    maxLength="15"
  />
</template>

<script>
export default {
  name: 'IdFilter',
  model: {
    prop: 'id'
  },
  props: {
    id: {
      type: [Number],
      required: false,
      default: null
    }
  },
  data: () => ({
    currentId: null
  }),
  created() {
    if (this.id) {
      this.currentId = this.id
    }
  },
  watch: {
    id() {
      this.currentId = this.id
    }
  },
  methods: {
    inputId(e) {
      if (e.target.value === '') {
        this.clear()
      } else {
        this.$emit('input', parseInt(e.target.value, 10))
      }
    },
    clear() {
      this.currentId = null
      this.$emit('input', null)
    },
    onKeydown() {
      let evt = window.event
      if (/\d/.test(evt.key)) {
        return true
      } else return evt.preventDefault()
    }
  }
}
</script>
